<script setup lang="ts">
import type { IProps } from './wellbeing-sale--dashboard.types'
import PhotoData from './wellbeing-sale--dashboard.const'
import type { IPhotoWithDescriptionFields } from '@/types/contentful.ts'
import UiPhotoWithDescription from '@/components/UiPhotoWithDescription/UiPhotoWithDescription.vue'

defineProps<IProps>()
const { uiPhotoData } = PhotoData()
</script>

<template>
  <div class="dashboard">
    <label class="dashboard__label">
      {{ $t('wellbeingSale.dashboardHR.label') }}
    </label>

    <h6 class="dashboard__title">
      {{ $t('wellbeingSale.dashboardHR.title') }}
    </h6>

    <p class="dashboard__paragraph">
      {{ $t('wellbeingSale.dashboardHR.paragraph1') }}
    </p>

    <UiPhotoWithDescription
      v-bind="uiPhotoData() as unknown as IPhotoWithDescriptionFields"
    >
      <template #custom-button>
        <UiButton
          size="big"
          :to="hookTo"
        >
          {{ $t('wellbeingSale.dashboardHR.button') }}
        </UiButton>
      </template>
    </UiPhotoWithDescription>

    <p
      class="dashboard__box"
      v-html="$t('wellbeingSale.dashboardHR.box')"
    />
  </div>
</template>

<style lang="scss" scoped>
.dashboard {
  max-width: 136rem;
  margin: auto;
  padding: 5rem 1.6rem;

  &__title {
    @include h8;
    padding-bottom: 1.6rem;
    color: $text-400;
    text-align: center;
  }

  &__label {
    @include h10;
    display: block;
    padding-bottom: .4rem;
    color: $purple-400;
    text-align: center;
  }

  &__paragraph {
    @include body-1-medium;
    padding-bottom: 3.2rem;
    text-align: center;
  }

  &__box {
    @include h10;
    padding: 2.4rem;
    background: rgba(246, 247, 252, 0.40);
    border: 1px solid $gray-50;
    border-radius: 1.2rem;
  }

  :deep(.purple) {
    color: $purple-400;
  }

  :deep(.cf-photoWithDescription__contentText--big) {
    @include h9;
    padding-bottom: 2.4rem;
  }

  :deep(.cf-photoWithDescription__listElement) {
    @include h10;
  }

  :deep(.cf-photoWithDescription--paragraph2) {
    @include body-1-medium;
  }

  :deep(.button) {
    display: block;
    margin-right: auto;
    margin-bottom: 4rem;
    margin-left: auto;
  }

  @include atXS {
    width: 90%;

    &__box {
      width: 80%;
      margin: auto;
    }
  }

  @include atS {
    padding: 10rem 0;

    &__title {
      @include h5;
      padding-bottom: 3.2rem;
    }

    &__paragraph {
      width: 50%;
      margin: auto;
      padding-bottom: 8rem;
    }

    :deep(.cf-photoWithDescription--paragraph1) {
      @include h9;
    }
  }

  @include atM {
    &__box {
      max-width: 65rem;
      margin-top: -10rem;
      margin-right: 0;
      margin-left: auto;
    }
  }

  @include atL {
    width: 100%;
  }
}

</style>
